module.exports = __webpack_public_path__ + "img/apgcl.e23aaa31.jpg";